module.exports = __webpack_public_path__ + "img/idcard_front.9461b0e6.png";